import { Component } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from 'src/app/controls/dialog/components/dialog.component';
import { SpeedTrialForm } from '../../models/speed-trial-form.interface';
import { SpeedTrialService } from '../../services/speed-trial.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SelectComponent } from 'src/app/controls/select/select.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StageResultsTableService } from '../../services/stage-results-table.service';
import { MatInputModule } from '@angular/material/input';
import { InputComponent } from 'src/app/controls/input/input.component';
import { CecBreakpointPipe } from 'src/app/controls/pipes/cec-breakpoint.pipe';
import { AsyncPipe } from '@angular/common';
import { SpeedTrial } from '../../models/speed-trial.interface';
import { StageResultBase } from '../../base/stage-result.base';

@Component({
  selector: 'cec-speed-trial-result-dialog',
  templateUrl: './speed-trial-result.component.html',
  styleUrls: ['./speed-trial-result.component.scss'],
  standalone: true,
  imports: [DialogComponent, TranslateModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, SelectComponent, MatSlideToggleModule, MatTooltipModule, MatInputModule, InputComponent, CecBreakpointPipe, AsyncPipe],
  providers: [SpeedTrialService, StageResultsTableService]
})
export class SpeedTrialResultComponent extends StageResultBase<SpeedTrialForm, SpeedTrial> {

  /** Speed trial create success message */
  protected successCreateKey = 'SpeedTrialCreateSuccess';

  /** Speed trial create fail message */
  protected failCreateKey = 'SpeedTrialCreateFailed';

  /** Speed trial update success message */
  protected successUpdateKey = 'SpeedTrialUpdateSuccess';

  /** Speed trial update fail message */
  protected failUpdateKey = 'SpeedTrialUpdateFailed';

  constructor(service: SpeedTrialService) {
    /** initializes crud service */
    super(service);

    /** builds a new speed trial form */
    this.formGroup = this.builder.group({
      crewId: [null as number | null, Validators.required],
      minutes: [0, Validators.required],
      seconds: [0, Validators.required],
      milliseconds: [0, Validators.required],
      points: [0, Validators.required],
    });
  }

  /** @inheritdoc */
  protected override getData(): SpeedTrial {
      return {
        id: this.id,
        ...this.formGroup.getRawValue(),
        stageId: this.stageId,
        stageResultId: this.stageResultId
      }
  }

  /** @inheritdoc */
  protected override fillFormGroup(data: SpeedTrial): void {
    this.id = data.id;
    this.formGroup.patchValue({...data});
  }
}
